export class ProFormulaVariableEntity{
    id:number;
    formulaId:number;
    type:string;
    variableId:number;
    variable:string;

    constructor(){}
}